module.exports = __webpack_public_path__ + "img/乐跑.6e2b691f.png";